import { render, staticRenderFns } from "./Touch.vue?vue&type=template&id=49929ffc&"
import script from "./Touch.vue?vue&type=script&lang=js&"
export * from "./Touch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports